// 初期表示
export const PAGE_INIT = "industry/report/PAGE_INIT";
export const LOAD_REPORT = "industry/report/LOAD_REPORT";
export const SORT_REPORT = "industry/report/SORT_REPORT";
export const SEARCH_REPORT = "industry/report/SEARCH_REPORT";
// 選択項目のセット
export const SET_ITEMS = "industry/report/SET_ITEMS";
export const SET_SORT_OPTIONS = "industry/report/SET_SORT_OPTIONS";
export const SET_COUNTRY_OPTIONS = "industry/report/SET_COUNTRY_OPTIONS";
